/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityEpssScore {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityEpssScore.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityEpssScore>): AppSecopsVulnerabilityEpssScore {
        let obj = Object.assign(new AppSecopsVulnerabilityEpssScore(), model);
        AppSecopsVulnerabilityEpssScore.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityEpssScore>): AppSecopsVulnerabilityEpssScore {
        if (!model) return null;
        return AppSecopsVulnerabilityEpssScore.newInstance(<AppSecopsVulnerabilityEpssScore> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityEpssScore) {
        if (!obj) return;

        models.AppSecopsVulnerabilityEpssScore.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityEpssScore): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityEpssScore.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.score === undefined) {
            this.score = 0;
        }
        if (this.percentile === undefined) {
            this.percentile = 0;
        }
        if (typeof this.calculated_at === "string") {
            this.calculated_at = new Date(<string><any>this.calculated_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * EPSS score indicating the likelihood of exploitation (0 to 1)
     */
    score: number;

    /**
     * EPSS percentile ranking among all scored vulnerabilities
     */
    percentile: number;

    /**
     * Timestamp when the EPSS score was generated
     */
    calculated_at: Date;

    /**
     * Timestamp when the score was recently updated
     */
    updated_at: Date;

}
